module.exports = __webpack_public_path__ + "static/media/09.989540c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/09.jpg
// module id = 699
// module chunks = 0